import { IconButton, TextField } from "@mui/material";
import { _ACTIVE_RADIO_GROUP } from "../../utils/constants";
import BasicRadioGroup from "../../components/form/BasicRadioGroup";
import _ from "lodash";
import { _ROUTES } from "../../utils/_routes_constants";
import { CalendarViewWeek } from "@mui/icons-material";
import { ListingPage } from "../../components/ListingPage";
import { useEffect, useState } from "react";
import { DataService } from "../../services/DataService";
import { TemplateModal } from "../../components/indicators/TemplateModal";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { ModuleRegistry, ServerSideRowModelModule } from "ag-grid-enterprise";

ModuleRegistry.registerModules([ServerSideRowModelModule]);

export const Templates = () => {
  const dataService = new DataService();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [gridApi, setGridApi] = useState(null);
  const [filterParams, setFilterParams] = useState({
    active: 1,
    "order[name]": "ASC",
  });
  const paginationItemsPerPage = 20;
  const paginationPageSize = 20;

  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.setGridOption("serverSideDatasource", createDatasource());
  };

  const createDatasource = () => {
    return {
      getRows: (params) => {
        setLoading(true);
        const { startRow, endRow } = params.request;
        const page = startRow / paginationPageSize + 1;

        dataService.doRequest(
          "GET",
          _ROUTES.INDICATORS_TEMPLATES,
          {
            ...filterParams,
            page,
          },
          {},
          (response) => {
            const rowData = response.member || [];
            const totalRowCount = response.totalItems || 0;
            setTotalItems(totalRowCount);
            setData(rowData);
            // Pass the rows and last row index to the grid
            params.success({
              rowData,
              rowCount: totalRowCount <= params.endRow ? totalRowCount : -1,
            });
            setLoading(false);
          },
          (error) => {
            console.error("Error fetching templates:", error);
            params.fail();
            setLoading(false);
          },
        );
      },
    };
  };

  useEffect(() => {
    // When filter params change, refresh the grid
    if (gridApi) {
      gridApi.setGridOption("serverSideDatasource", createDatasource());
    }
  }, [filterParams]);

  const handleAddNew = () => {
    setModalData(null);
    setShowModal(true);
  };

  const handleDataMutation = (oldData, newData) => {
    if (oldData) {
      const index = _.findIndex(data, { id: oldData.id });
      data[index] = newData;
    } else {
      data.push(newData);
    }
    setData([...data]);

    // Refresh the grid after data mutation
    if (gridApi) {
      gridApi.setGridOption("serverSideDatasource", createDatasource());
    }
  };

  const handleSearch = (searchText) => {
    if (searchText) {
      setFilterParams((prev) => ({
        ...prev,
        name: searchText,
      }));
    } else {
      const newParams = { ...filterParams };
      delete newParams.name;
      setFilterParams(newParams);
    }
  };

  const handleActiveChange = (value) => {
    setFilterParams((prev) => ({
      ...prev,
      active: value,
    }));
  };

  return (
    <>
      <TemplateModal
        showModal={showModal}
        setShowModal={setShowModal}
        editData={modalData}
        onDataMutation={handleDataMutation}
      />
      <ListingPage
        icon={<CalendarViewWeek />}
        title={"Templates"}
        isDataLoading={loading}
        data={data}
        defaultColDef={{ suppressHeaderMenuButton: true }}
        columns={[
          {
            headerName: "Name",
            field: "name",
          },
          {
            headerName: "Activity",
            field: "activity",
            valueFormatter: (params) => params.data.activity?.name,
          },
          {
            headerName: "Sites",
            field: "sites",
            valueFormatter: (params) =>
              params.data.sites?.map((site) => site.name).join(", "),
          },
          {
            headerName: "Active",
            field: "active",
            cellRenderer: (params) => {
              return params.data.active ? <CheckIcon /> : <ClearIcon />;
            },
          },
          {
            headerName: "Actions",
            field: "actions",
            cellRenderer: (params) => {
              return (
                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setModalData(params.data);
                    setShowModal(true);
                  }}
                >
                  <EditIcon />
                </IconButton>
              );
            },
          },
        ]}
        addButton={{
          title: "Add a template",
          onClick: handleAddNew,
        }}
        filterComponents={
          <>
            <TextField
              id="outlined-basic"
              label="Find"
              variant="outlined"
              size="small"
              name="customFind"
              onBlur={(e) => {
                handleSearch(e.target.value);
              }}
            />
            <BasicRadioGroup
              choices={_ACTIVE_RADIO_GROUP}
              defaultValue={_ACTIVE_RADIO_GROUP[0].value}
              onChange={(e) => {
                handleActiveChange(e.target.value);
              }}
            />
          </>
        }
        agGridProps={{
          rowModelType: "serverSide",
          pagination: true,
          cacheBlockSize: paginationItemsPerPage,
          paginationPageSize: paginationPageSize,
          paginationAutoPageSize: false,
          paginationPageSizeSelector: false,
          onGridReady: onGridReady,
          rowCount: totalItems,
        }}
      />
    </>
  );
};
